/**
 * @file lib/app-version.ts
 * @description 前端構建版本資訊（由 vite `define` 在編譯期注入）。
 *
 * `__APP_*__` 三個常量在 `vite.config.ts` 的 `define` 中以 git short SHA、
 * package version、構建時間戳替換。dev 或無 git 環境下回落為占位值。
 *
 * 用 `typeof` 守衛是為了相容 vitest 等未套用 vite define 的執行環境
 * （對未宣告識別字取 typeof 不會拋 ReferenceError）。
 */

declare const __APP_VERSION__: string;
declare const __APP_GIT_SHA__: string;
declare const __APP_BUILT_AT__: string;

/** 前端構建版本資訊 */
export const appVersion = {
  /** package.json version，如 "0.2.0" */
  version: typeof __APP_VERSION__ !== 'undefined' ? __APP_VERSION__ : '0.0.0',
  /** git short SHA，如 "423440a"；dev 環境為 "dev" */
  gitSha: typeof __APP_GIT_SHA__ !== 'undefined' ? __APP_GIT_SHA__ : 'dev',
  /** 構建時間戳（ISO）；dev 環境為配置載入時刻 */
  builtAt: typeof __APP_BUILT_AT__ !== 'undefined' ? __APP_BUILT_AT__ : '',
} as const;
